// Declared twice so that docs appear when selecting colors
export interface EinsteinPalette extends Record<string, string> {
  /** **#EFF5DD** Yellow-green */
  readonly einstein10: string;
  /** **#E3EEBD** Yellow-green */
  readonly einstein30: string;
  /** **#CFE57E** Yellow-green */
  readonly einstein60: string;
  /** **#B9D340** Yellow-green */
  readonly einsteinPrimary: string;
  /** **#8C9F34** Yellow-green */
  readonly einstein80: string;
  /** **#5A6C06** Yellow-green */
  readonly einstein90: string;
}

export const einsteinPalette: EinsteinPalette = {
  einstein10: '#EFF5DD',
  einstein30: '#E3EEBD',
  einstein60: '#CFE57E',
  einsteinPrimary: '#B9D340',
  einstein80: '#8C9F34',
  einstein90: '#5A6C06',
};
